<div class="main" style="padding: 40px" fxFlex.xl="55" fxFlex.lg="70" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
  <div fxLayout="column wrap" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div *ngFor="let integration of settingsModel" fxFlex="45" fxFlex.lt-md="100">
      <app-contact-single-integration
        [integration]="integration"
        [customFieldData]="customFieldData$.asObservable() | async"
        (integrationChanged)="integrationChanged($event)"
      ></app-contact-single-integration>
    </div>
  </div>

  <div fxLayout="column wrap" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div fxFlex="45" fxFlex.lt-md="100">
      <mat-card appearance="outlined">
        <mat-card-title>Import from CSV</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
          <div fxLayout="column" fxLayoutAlign="start start">
            @if (importCsvError) {
              <div style="width: 100%">
                <p-message severity="error" icon="pi pi-exclamation-triangle">
                  <span class="p-message-detail">{{ importCsvError }}</span>
                </p-message>
              </div>
            }
            <div style="width: 100%">
              <p-message severity="warn" icon="pi pi-exclamation-triangle">
                <span>
                  Use this
                  <a href="https://storage.googleapis.com/telego_public/contacts_import_v2_example.csv">
                    csv template
                  </a>
                  to import contacts. Do not change to column headers, or else your import will not be
                  successful.
                </span>
              </p-message>
            </div>

            <label>Browse or drag csv file here</label>
            <input
              #fileInput
              id="upload-csv"
              class="file-input"
              type="file"
              (change)="fileChangeEvent($event)"
              placeholder="Choose a file..."
            />
            <div class="file-drop-area" appDroppable (dropped)="dropFile($event)">
              <div>Drop File Here</div>
            </div>
          </div>
          <div class="duplicates-wrapper" fxLayout="column" fxLayoutAlign="start start">
            <mat-label>Duplicate contacts merge options</mat-label>
            <mat-radio-group
              aria-label="Duplicate contacts merge options"
              [(ngModel)]="importMergeOptions.importMergeType"
              (ngModelChange)="onImportOptionsChange($event)"
            >
              <mat-radio-button value="skip"> Do not import contact if:</mat-radio-button>
              <div class="checkbox-group">
                <mat-checkbox
                  [(ngModel)]="importMergeOptions.importSkipByMobilePhone"
                  [disabled]="importMergeOptions.importMergeType !== 'skip'">
                  Mobile phone number is same
                </mat-checkbox>
                <mat-checkbox
                  [(ngModel)]="importMergeOptions.importSkipByEmailAddress"
                  [disabled]="importMergeOptions.importMergeType !== 'skip'">
                  Email address is same
                </mat-checkbox>
              </div>
              <mat-radio-button value="append"> Replace existing contact if:</mat-radio-button>
              <div class="checkbox-group">
                <mat-checkbox
                  [(ngModel)]="importMergeOptions.importMergeByMobilePhone"
                  [disabled]="importMergeOptions.importMergeType !== 'append'"
                >Mobile phone number is same
                </mat-checkbox>
                <mat-checkbox
                  [(ngModel)]="importMergeOptions.importMergeByEmailAddress"
                  [disabled]="importMergeOptions.importMergeType !== 'append'"
                >Email address is same
                </mat-checkbox>
              </div>
              <mat-radio-button value="all"> Import all contacts</mat-radio-button>
            </mat-radio-group>
          </div>
        </mat-card-content>
        <mat-card-actions>
          @if (hasEditAccess) {
            <button
              mat-raised-button
              type="button"
              color="primary"
              matTooltip="Import"
              [promiseBtn]="buttonImportPromise"
              [disabled]="!filesToUpload?.length"
              (click)="onImport($event)">
              Import
            </button>
          }
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
